import * as z from "zod/v4";

export const subscriptionPreOrderDeliveryProfileSettingsSchema = z.object({
  enabled: z.boolean().optional(),
  deliveryProfileId: z.string().optional(),
});
export type SubscriptionPreOrderDeliveryProfileSettings = z.infer<
  typeof subscriptionPreOrderDeliveryProfileSettingsSchema
>;

export const subscriptionPreOrderDeliveryProfileSettingsDefault = {
  enabled: false,
  deliveryProfileId: undefined,
} as const;
